const returnDate = (date: string | number | Date) => {
  const dateObject = new Date(date);
  return dateObject.toLocaleString();
};

export default returnDate;
